var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsiveDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2e63",
    d: "M37.6,43.7c0,0.5-0.4,1-1,1H23.1c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h13.5C37.2,42.7,37.6,43.1,37.6,43.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2e63",
    d: "M60.7,20.8h-6.1V7.1c0-1.6-1.4-2.9-3-2.9H7.9c-1.7,0-3,1.3-3,2.9v30l-4.8,9.2C0,46.4,0,46.6,0,46.7c0,1.2,1,2.2,2.3,2.2h39.3v7.7c0,1.8,1.5,3.2,3.3,3.2h15.9c1.8,0,3.3-1.4,3.3-3.2V24C64,22.3,62.5,20.8,60.7,20.8z M6.8,7.1c0-0.5,0.5-1,1.1-1h43.7c0.6,0,1.1,0.4,1.1,1v13.8h-2V10c0-1-0.9-1.9-2-1.9h-38c-1.1,0-2,0.8-2,1.9v22.5c0,1,0.9,1.9,2,1.9h30.8v2H6.8V7.1z M2.3,47C2.2,47,2,46.9,2,46.9l4.4-8.6h35.2l0,8.7H2.3z M41.6,24.2v8.2l-30.8,0.1l0-22.4l38-0.1v10.8H45C43.1,20.8,41.6,22.4,41.6,24.2z M62.1,56.6c0,0.7-0.6,1.3-1.3,1.3H44.8c-0.7,0-1.3-0.6-1.3-1.3v-3h18.5V56.6z M62.1,51.7H43.5V33.4c0,0,0,0,0,0c0,0,0,0,0,0l0-5h18.5V51.7z M62.1,26.4H43.5v-2.2c0-0.8,0.6-1.4,1.5-1.4h15.8c0.7,0,1.3,0.6,1.3,1.3V26.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M48.8,10v10.8H45c-1.9,0-3.4,1.5-3.4,3.4v8.2l-30.8,0.1l0-22.4L48.8,10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f26e61",
    d: "M41.6 38.3H6.4L2 46.9C2 46.9 2.2 47 2.3 47h39.3L41.6 38.3zM36.6 44.6H23.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1h13.5c.5 0 1 .4 1 1C37.6 44.2 37.2 44.6 36.6 44.6zM52.7 7.1v13.8h-2V10c0-1-.9-1.9-2-1.9h-38c-1.1 0-2 .8-2 1.9v22.5c0 1 .9 1.9 2 1.9h30.8v2H6.8V7.1c0-.5.5-1 1.1-1h43.7C52.2 6.1 52.7 6.6 52.7 7.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6d6d6",
    points: "48.8 10 48.8 20.8 47.8 20.8 47.8 11 11.8 11.1 11.8 31.5 41.6 31.4 41.6 32.4 10.8 32.5 10.8 10.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e15e5a",
    d: "M41.6 46v1H2.3C2.2 47 2 46.9 2 46.9l4.4-8.6h1.1l-4 7.7H41.6zM52.7 7.1v13.8h-1l0-13.7c0 0-.1 0-.1 0H7.9c0 0-.1 0-.1 0 0 0 0 0 0 0v29.2h-1V7.1c0-.5.5-1 1.1-1h43.7C52.2 6.1 52.7 6.6 52.7 7.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f26e61",
    d: "M51.7,20.8V10c0-1.6-1.3-2.9-3-2.9h2.9c0.1,0,0.1,0,0.1,0L51.7,20.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M62.1,28.3v23.4H43.5V33.4c0,0,0,0,0,0c0,0,0,0,0,0l0-5H62.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#51bf9f",
    d: "M43.5 53.6v3c0 .7.6 1.3 1.3 1.3h15.9c.7 0 1.3-.6 1.3-1.3v-3H43.5zM53.8 56.8c-.3.3-.6.4-1 .4s-.8-.1-1-.4c-.6-.6-.6-1.5 0-2.1.3-.3.6-.4 1-.4s.8.2 1 .4C54.4 55.3 54.4 56.2 53.8 56.8zM60.7 22.8H45c-.8 0-1.5.6-1.5 1.4v2.2h18.5V24C62.1 23.3 61.5 22.8 60.7 22.8zM55.2 25.5h-4.9c-.5 0-1-.4-1-1 0-.5.4-1 1-1h4.9c.5 0 1 .4 1 1C56.2 25.1 55.8 25.5 55.2 25.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 23.4,
    x: 61.1,
    y: 28.3,
    fill: "#d6d6d6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d6d6",
    d: "M44.5,33.4v18.3h-1V33.4c0,0,0,0,0,0c0,0,0,0,0,0l0-5h1L44.5,33.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3da580",
    d: "M62.1 53.6v3c0 .7-.6 1.3-1.3 1.3H44.8c-.7 0-1.3-.6-1.3-1.3v-3h1v3c0 .2.1.3.3.3h15.9c.2 0 .3-.1.3-.3v-3H62.1zM62.1 24v2.3h-1V24c0-.1-.2-.3-.3-.3H45c-.3 0-.5.2-.5.4v2.2h-1v-2.2c0-.8.6-1.4 1.5-1.4h15.8C61.5 22.8 62.1 23.3 62.1 24z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2e63",
    d: "M56.2 24.6c0 .5-.4 1-1 1h-4.9c-.5 0-1-.4-1-1 0-.5.4-1 1-1h4.9C55.8 23.6 56.2 24 56.2 24.6zM53.8 54.7c-.3-.3-.6-.4-1-.4s-.8.2-1 .4c-.6.6-.6 1.5 0 2.1.3.3.6.4 1 .4s.8-.1 1-.4C54.4 56.2 54.4 55.3 53.8 54.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveDesign);
export default __webpack_public_path__ + "static/media/responsive-design.e7533dbe729e39f41a7c15f38748366d.svg";
export { ForwardRef as ReactComponent };